function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1962 5093 c-22 -20 -1706 -2884 -1931 -3284 -38 -67 -39 -102 -6 -134 l24 -25 1806 0 1805 0 0 501 0 502 -87 -6 c-221 -14 -451 -93 -639 -219 -83 -56 -122 -61 -159 -24 -35 35 -38 62 -26 206 19 215 65 364 152 492 43 63 130 156 181 195 l28 21 -516 883 c-284 486 -521 890 -528 896 -6 7 -25 15 -42 19 -26 5 -37 1 -62 -23z m167 -822 c62 -32 98 -68 128 -129 l28 -57 0 -610 c0 -558 -1 -613 -17 -648 -50 -110 -145 -173 -258 -171 -36 0 -81 8 -101 16 -55 24 -119 87 -145 143 l-24 50 0 610 0 610 25 50 c38 80 81 120 157 147 64 23 149 18 207 -11z m7 -1834 c132 -67 185 -228 120 -361 -48 -98 -131 -149 -241 -150 -116 -1 -202 54 -251 159 -68 144 16 327 170 375 52 16 146 5 202 -23z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1983 4108 c-64 -17 -63 -6 -63 -633 0 -581 1 -593 39 -622 28 -22 89 -16 116 12 l25 24 0 583 c0 637 2 615 -57 635 -17 6 -41 6 -60 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1963 2271 c-61 -38 -50 -136 18 -160 37 -13 91 6 108 37 45 84 -47 172 -126 123z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3685 3373 c-209 -28 -390 -119 -545 -273 -82 -82 -130 -156 -166 -254 -23 -64 -46 -196 -34 -196 3 0 42 17 85 39 169 82 338 125 555 142 108 8 156 8 187 0 68 -18 73 -37 73 -261 l0 -190 274 0 274 0 4 178 c4 201 11 226 88 296 100 90 237 98 366 20 57 -34 58 -35 163 -32 l106 3 0 265 0 265 -106 3 c-103 3 -108 2 -155 -27 -66 -41 -163 -65 -229 -56 -53 6 -167 54 -179 74 -5 8 -115 11 -369 10 -199 -1 -375 -4 -392 -6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3840 1217 c0 -1121 -6 -1042 85 -1134 112 -111 269 -111 381 2 90 89 84 18 82 1135 l-3 975 -272 3 -273 2 0 -983z m335 -601 c32 -32 38 -70 33 -235 -3 -136 -4 -141 -29 -167 -36 -36 -92 -36 -128 0 -26 26 -26 29 -29 182 -4 166 3 202 42 229 32 23 83 19 111 -9z"
}));
function SvgControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControl);
export default __webpack_public_path__ + "static/media/control.3d1e70fadb734bd09529ce00c579de62.svg";
export { ForwardRef as ReactComponent };